import React from "react";
import { Link } from "react-router-dom";

const Header = (props) => {
  const logo = require("../assets/img/logo/logo.png");
  return (
    <>
      <nav class={`navbar navbar-dark ${props.bg ? props.bg : "bg-dark"}`}>
        <div className="container-fluid">
          <Link className="navbar-brand" style={{ width: "15%" }} to="/">
            <img src={logo} className="img-fluid" alt="" />{" "}
          </Link>
          {/* <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasNavbar"
            aria-controls="offcanvasNavbar"
          >
            <span className="navbar-toggler-icon"></span>
          </button> */}
          {/* <div
            className="offcanvas offcanvas-end "
            tabindex="-1"
            id="offcanvasNavbar"
            aria-labelledby="offcanvasNavbarLabel"
          > */}
          {/* <div className="offcanvas-header">
              <h5 className="offcanvas-title" id="offcanvasNavbarLabel">
                Nathan
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div> */}
          {/* <div className="offcanvas-body"> */}
          {/* <ul className="navbar-nav justify-content-end flex-grow-1 pe-3"> */}
          {/* <li className="nav-item">
                  <NavLink
                    className="nav-link active"
                    aria-current="page"
                    to="#"
                  >
                    Home
                  </NavLink>
                </li> */}

          {/* <li className="nav-item dropdown">
                  <NavLink
                    className="nav-link dropdown-toggle"
                    to="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Dropdown
                  </NavLink>
                  <ul className="dropdown-menu">
                    <li>
                      <NavLink className="dropdown-item" to="#">
                        Action
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="#">
                        Another action
                      </NavLink>
                    </li>
                    <li>
                      <hr className="dropdown-divider" />
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="#">
                        Something else here
                      </NavLink>
                    </li>
                  </ul>
                </li> */}
          {/* </ul> */}
          {/* </div> */}
          {/* </div> */}
        </div>
      </nav>
      {/* Mobile nav  */}
    </>
  );
};

export default Header;
